import i18next from "i18next";
import React from "react";
import { Mail, Phone, Info } from "react-feather";
import OverviewSection from "../../Checkout/sections/OrderOverview/OverviewSection";

const ContactInfo = () => {
    return (
        <OverviewSection>
            <div className="contact_info">
                <div className="contact_info_icon">
                    <Info />
                </div>
                <div className="contact_info_content">
                    <div className="contact_info_heading">
                        <p>
                            {i18next.t("orderConfirmation.contactInfo.heading")}
                        </p>
                    </div>
                    <p className="contact_info_notice">
                        {i18next.t("orderConfirmation.contactInfo.notice")}
                    </p>
                    <div className="contact_info_mail">
                        <Mail style={{ stroke: "#00ea17" }}></Mail>
                        <p>
                            {i18next.t("orderConfirmation.contactInfo.email")}
                        </p>
                    </div>
                </div>
            </div>
        </OverviewSection>
    );
};

export default ContactInfo;
